// extracted by mini-css-extract-plugin
module.exports = {"root":"BackgroundImage__root___3F7n5","image":"BackgroundImage__image___1Ggow"};